import cn from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import ToggleSwitch from 'app/components/shared/ToggleSwitch';

import HelpLinkContainer from 'app/components/shared/HelpLink/HelpLinkContainer';

import './AllLanguagesToggle.scss';

const AllLanguagesToggle = ({ className, inputId, isActive, onChange }) => {
  return (
    <div className={cn('cp-all-languages-toggle', className)}>
      <ToggleSwitch
        active={isActive}
        activeText={<FormattedMessage id="include_translations" />}
        handleClick={onChange}
        id={inputId}
        inactiveText={<FormattedMessage id="include_translations" />}
      />
      <HelpLinkContainer className="help-link" page="045faq/030faq-searching/#trans" />
    </div>
  );
};

AllLanguagesToggle.defaultProps = {
  className: ''
};

AllLanguagesToggle.propTypes = {
  className: PropTypes.string,
  inputId: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
};

export default AllLanguagesToggle;
